var map = {
	"./QR_1083.png": "37b2",
	"./QR_1085.png": "e6db",
	"./QR_1086.png": "971f",
	"./QR_wechat_official.png": "2bc6",
	"./QR_wechat_person.png": "6499",
	"./QR_wechat_video.png": "13a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "14d6";